(() => {
  'use strict';
  const roots=document.querySelectorAll('[data-bloom-root]');
  // One installation per page. Never initialize a duplicate section against shared IDs.
  if(roots.length!==1){if(roots.length)console.warn('[Bloom Rail] DUPLICATE_SECTION');return;}
  const root=roots[0];if(root.dataset.initialized)return;
  const content=root.querySelector('[data-bloom-content]');
  try {
    const raw=JSON.parse(root.querySelector('[data-bloom-payload]').textContent);
    const {config,ui,diagnostics}=window.BloomRailNormalize(raw,window.BloomRailPresentation);
    content.hidden=false;
    window.BloomRailMount(root,config,ui);
    root.querySelector('.integration-status').hidden=true;
    root.dataset.initialized='true';
    // Developer console only: never expose data paths, IDs or stack traces to customers.
    if(diagnostics.length)console.warn('[Bloom Rail]',diagnostics.join('; '));
  } catch(error) {
    content.hidden=true;
    root.querySelector('.integration-status').hidden=false;
    console.warn('[Bloom Rail] Hydration unavailable:',error instanceof SyntaxError?'INVALID_JSON':error.message);
  }
})();
